import type { LcIconProps } from '@lottocom/frontend-components'

import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

export const useNumberLotteryTheme = (lotteryId: LotteryId) => {
  const { t } = useI18n()
  const licensedTerritory = useLicensedTerritory()

  const cssVar = (name: string) => {
    if (!licensedTerritory) return undefined
    return getLotteryCssVarConstructor(licensedTerritory, lotteryId).createCssVar(name)
  }

  const extraBallBg = computed(() => cssVar('extra-ball-bg'))

  const extraBallColor = computed(() => cssVar('extra-ball-color'))

  const extraHitIcon = computed(
    () => `hit-${t(`lottery.${lotteryId}.extrahit`).toLowerCase()}` as LcIconProps['name'],
  )

  return { extraBallBg, extraBallColor, extraHitIcon }
}
